<app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>

<div class="row">
  <div class="col-md-12 mx-auto">
    <h3>Lista de Nominas</h3>
  </div>
  <hr />
  <div class="row align-items-center mb-3">
    <div class="col-md-12">
      <div class="d-grip gap-1 d-md-flex justify-content-md-end">
        <a (click)="openCreateReport()" class="btn btn-outline-success">
          <i class="bi bi-plus-circle"></i>
          Generar Nomina
        </a>
      </div>
    </div>
  </div>
  <hr />

  <ngb-accordion [closeOthers]="true" activeIds="static-0" class="mt-3">
    <ngb-panel
      *ngFor="let report of payrolls; let i = index"
      id="static-{{ i }}"
      title="Nomina del {{ report.cycle_date_start }} al {{
        report.cycle_date_end
      }}"
    >
      <ng-template ngbPanelContent>
        <div class="accordion-body">
          <table class="table table-striped">
            <thead class="table-dark">
              <tr>
                <td>Colaborador</td>
                <td>Email</td>
                <td>Telefono</td>
                <td>Total</td>
                <td>Opciones</td>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let employee of report.employees">
                <td>{{ employee.user.name }}</td>
                <td>{{ employee.user.email }}</td>
                <td>{{ employee.user.phone }}</td>
                <td>{{ employee.total_paid | currency }}</td>
                <td>
                  <div class="me-2">
                    <a
                      [routerLink]="['/payrolls/show', employee.user.payrollId]"
                      placement="top"
                      ngbTooltip="Motrar Nomina"
                      role="button"
                      class="btn btn-primary"
                    >
                      <i class="bi bi-eye-fill"></i>
                    </a>
                    <!-- <a
                      (click)="downloadPDF(report.payroll_id)"
                      class="btn btn-primary ms-2"
                      placement="top"
                      ngbTooltip="Descargar Nomina PDF"
                      role="button"
                    >
                      <i class="bi bi-file-earmark-arrow-down-fill"></i>
                    </a> 
                    downloadExcel(employee.user.payrollId, employee.user.id)
                    -->
                    <span *ngIf="!employee.path_file">
                      <a
                        (click)="
                          openDeductions(
                            employee.user.payrollId,
                            employee.user.id,
                            employee.user.name,
                            employee.user.role.key
                          )
                        "
                        placement="top"
                        ngbTooltip="Descargar Nomina Excel"
                        role="button"
                        class="btn btn-primary ms-2"
                      >
                        <i class="bi bi-file-earmark-excel-fill"></i>
                      </a>
                    </span>
                    <span *ngIf="employee.path_file">
                      <a
                        (click)="
                          downloadExcelFile(
                            employee.user.payrollId,
                            employee.user.id,
                            employee.deduction,
                            employee.user.role.key
                          )
                        "
                        placement="top"
                        ngbTooltip="Descargar Nomina Excel"
                        role="button"
                        class="btn btn-primary ms-2"
                      >
                        <i class="bi bi-file-earmark-excel-fill"></i>
                      </a>
                    </span>
                    <a
                      (click)="
                        openGifts(employee.user.name, employee.user.payrollId)
                      "
                      placement="top"
                      ngbTooltip="Agregar Premios"
                      role="button"
                      class="btn btn-primary ms-2"
                    >
                      <i class="bi bi-gift-fill"></i>
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-template>
    </ngb-panel>
  </ngb-accordion>

  <ng-template #addPrizes let-close="close">
    <div class="modal-header">
      <h4 class="modal-title">Premios para {{ userName }}</h4>
      <button class="close ms-auto modal-close-btn" type="button" (click)="close()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
    <div class="modal-body">
      <p>Agrega Premios</p>
      <div class="row ms-2 me-2">
        <ngb-alert
          #selfClosingAlert
          type="danger"
          *ngIf="message != '' && flagErrors"
        >
          {{ message }}
        </ngb-alert>
        <ngb-alert
          #selfClosingAlert
          type="success"
          *ngIf="message != '' && isSaved"
        >
          {{ message }}
        </ngb-alert>
        <form [formGroup]="prizesForm" (ngSubmit)="addPrizesForm()" novalidate>
          <input
            type="hidden"
            name="payrollId"
            id="payrollId"
            class="form-control"
            formControlName="payrollId"
          />
          <div class="row">
            <div class="input-group mb-3">
              <span class="input-group-text">$</span>
              <input
                type="text"
                class="form-control"
                id="amount"
                name="amount"
                formControlName="amount"
                placeholder="Cantidad del premio semana 1"
                required
                [ngClass]="{
                  'is-invalid': submitted && f.amount.errors,
                  'is-valid': submitted && !f.amount.errors
                }"
              />
            </div>
          </div>

          <div class="row">
            <div class="input-group mb-3">
              <span class="input-group-text">$</span>
              <input type="text" id="amount2" class="form-control" name="amount2" formControlName="amount2" 
                placeholder="Cantidad del premio semana 2" required
                [ngClass]="{
                  'is-invalid': submitted && f.amount2.errors,
                  'is-valid': submitted && !f.amount2.errors
                }" />
            </div>
          </div>

          <div class="d-grip gap-2 d-md-flex justify-content-md-end">
            <button
              class="btn btn-outline-danger"
              type="button"
              (click)="close()"
            >
              Cerrar
            </button>
            <button type="submit" class="btn btn-outline-success">
              Confirmar
            </button>
          </div>
        </form>
      </div>
    </div>
  </ng-template>

  <ng-template #createReportModal let-close="close">
    <div class="modal-header">
      <h4 class="modal-title">Generaci&oacute;n de Nominas</h4>
      <button class="close ms-auto modal-close-btn" type="button" (click)="close()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
    <div class="modal-body">
      <div class="row ms-2 me-2">
        <ngb-alert
          #selfClosingAlert
          type="danger"
          *ngIf="message != '' && flagErrors"
        >
          {{ message }}
        </ngb-alert>
        <ngb-alert
          #selfClosingAlert
          type="success"
          *ngIf="message != '' && isSaved"
        >
          {{ message }}
        </ngb-alert>
        <form
          [formGroup]="generatePayroll"
          (ngSubmit)="generatePayrollForm()"
          novalidate
        >
          <div class="row">
            <div class="form-floating mb-3 col-md-12">
              <select
                name="cycleId"
                id="cycleId"
                class="form-select"
                aria-label="floating label select"
                formControlName="cycleId"
                [ngClass]="{
                  'is-invalid': submitted && fg.cycleId.errors,
                  'is-valid': submitted && !fg.cycleId.errors
                }"
              >
                <option value="" selected>Selecciona ciclo de pago</option>
                <option value="{{ cycle.id }}" *ngFor="let cycle of cycles">
                  {{ cycle.cycle }}
                </option>
              </select>
              <label for="cycleId" class="ms-2"> Selecciona una oficina </label>
            </div>
          </div>
          <div class="d-grip gap-2 d-md-flex justify-content-md-end">
            <button
              class="btn btn-outline-danger"
              type="button"
              (click)="close()"
            >
              Cancelar
            </button>
            <button type="submit" class="btn btn-outline-success">
              Generar
            </button>
          </div>
        </form>
      </div>
    </div>
  </ng-template>

  <ng-template #addDeductions let-close="close">
    <div class="modal-header">
      <h4 class="modal-title">Deducciones de {{ userName }}</h4>
      <button class="close ms-auto modal-close-btn" type="button" (click)="close()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
    <div class="modal-body">
      <p>Agrega Deducciones</p>
      <div class="row ms-2 me-2">
        <form
          [formGroup]="generateDeductions"
          (ngSubmit)="downloadExcel()"
          novalidate
        >
          <input
            type="hidden"
            name="payrollId"
            id="payrollId"
            class="form-control"
            formControlName="payrollId"
          />
          <input
            type="hidden"
            name="userId"
            id="userId"
            class="form-control"
            formControlName="userId"
          />
          <div class="row">
            <div class="input-group mb-3">
              <span class="input-group-text">$</span>
              <input
                type="text"
                class="form-control"
                id="deduction"
                name="deduction"
                formControlName="deduction"
                placeholder="Deducciones totales"
                required
                [ngClass]="{
                  'is-invalid': submitted && gdv.deduction.errors,
                  'is-valid': submitted && !gdv.deduction.errors
                }"
              />
            </div>
            <div class="mb-3">
              <input
                type="text"
                class="form-control"
                id="reason"
                name="reason"
                formControlName="reason"
                placeholder="Concepto de la deducción"
                required
                [ngClass]="{
                  'is-invalid': submitted && gdv.reason.errors,
                  'is-valid': submitted && !gdv.reason.errors
                }"
              />
            </div>
          </div>
          <div class="d-grip gap-2 d-md-flex justify-content-md-end">
            <button
              class="btn btn-outline-danger"
              type="button"
              (click)="close()"
            >
              Cerrar
            </button>
            <button type="submit" class="btn btn-outline-success">
              Descargar Nomina
            </button>
          </div>
        </form>
      </div>
    </div>
  </ng-template>

  <ng-template #addExtrasNurse let-close="close">
    <div class="modal-header">
      <h4 class="modal-title">Extras de {{ userName }}</h4>
      <button class="close ms-auto modal-close-btn" type="button" (click)="close()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
    <div class="modal-body">
      <div class="row ms-2 me-2">
        <form
          [formGroup]="generateExtras"
          (ngSubmit)="downloadExcelNurse()"
          novalidate
        >
          <input
            type="hidden"
            name="payrollId"
            id="payrollId"
            class="form-control"
            formControlName="payrollId"
          />
          <input
            type="hidden"
            name="userId"
            id="userId"
            class="form-control"
            formControlName="userId"
          />
          <div class="row">
            <label for="deductions">Deducciones Semana 1</label>
            <div class="mb-3 col-md-6">
              <input
                type="text"
                class="form-control"
                id="reason"
                name="reason"
                formControlName="reason"
                placeholder="Concepto de la deducción semana 1"
                required
              />
            </div>
            <div class="col-md-6">
              <div class="input-group mb-3">
                <span class="input-group-text">$</span>
                <input
                  type="text"
                  class="form-control"
                  id="deduction"
                  name="deduction"
                  formControlName="deduction"
                  placeholder="Deducciones semana 1"
                  required
                />
              </div>
            </div>
          </div>

          <div class="row">
            <label for="deductions">Deducciones Semana 2</label>
            <div class="mb-3 col-md-6">
              <input
                type="text"
                class="form-control"
                id="reason_2"
                name="reason_2"
                formControlName="reason_2"
                placeholder="Concepto de la deducción semana 2"
                required
              />
            </div>
            <div class="col-md-6">
              <div class="input-group mb-3">
                <span class="input-group-text">$</span>
                <input
                  type="text"
                  class="form-control"
                  id="deduction_2"
                  name="deduction_2"
                  formControlName="deduction_2"
                  placeholder="Deducciones semana 2"
                  required
                />
              </div>
            </div>
          </div>

          <div class="row">
            <label for="deductions">Dias festivos</label>
            <div class="col-md-6">
               <div class="input-group">
                <input
                  type="text"
                  name="dateSession"
                  class="form-control"
                  id="dateSession"
                  formControlName="dateSession"
                  placeholder="Seleccione el dia festivo"
                  ngbDatepicker
                  #d="ngbDatepicker"
                  required
                  readonly
                  style="height: 3.5rem"
                />
                <button
                  class="btn btn-outline-secondary bi bi-calendar3"
                  (click)="d.toggle()"
                  type="button"
                ></button>
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group mb-3" style="height: 55px;">
                <span class="input-group-text">$</span>
                <input
                  type="text"
                  class="form-control"
                  id="amountOff"
                  name="amountOff"
                  formControlName="amountOff"
                  placeholder="Dia festivo semana 2"
                  required
                />
              </div>
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-md-4">
              <label for="">Bono tratamientos</label>
              <input
                  type="text"
                  class="form-control"
                  id="threatment"
                  name="threatment"
                  formControlName="threatment"
                  placeholder="Bono tratamientos"
                  required
                />
            </div>
            <div class="col-md-4">
              <label for="">Bono asistencia y puntualidad</label>
              <input
                  type="text"
                  class="form-control"
                  id="assistance"
                  name="assistance"
                  formControlName="assistance"
                  placeholder="Bono asistencia y puntualidad"
                  required
                />
            </div>
            <div class="col-md-4">
              <label for="">Bono bodega</label>
              <input
                  type="text"
                  class="form-control"
                  id="bonus_store"
                  name="bonus_store"
                  formControlName="bonus_store"
                  placeholder="Bono bodega"
                  required
                />
            </div>
          </div>

          <div class="d-grip gap-2 d-md-flex justify-content-md-end">
            <button
              class="btn btn-outline-danger"
              type="button"
              (click)="close()"
            >
              Cerrar
            </button>
            <button type="submit" class="btn btn-outline-success">
              Descargar Nomina
            </button>
          </div>
        </form>
      </div>
    </div>
  </ng-template>
</div>
